import * as actionTypes from "./actionTypes";

export const setBalanceBillViewState = (balanceBillView) => {
  return {
    type: actionTypes.SET_BALANCE_BILL_VIEW_STATE,
    balanceBillView: balanceBillView,
  };
};
export const resetBalanceBillViewState = () => {
  return {
    type: actionTypes.RESET_BALANCE_BILL_VIEW_STATE,
  };
};
export const setMyBillViewState = (myBillView) => {
    return {
      type: actionTypes.SET_MY_BILL_VIEW_STATE,
      myBillView: myBillView,
    };
  };
  export const resetMYBillViewState = () => {
    return {
      type: actionTypes.RESET_MY_BILL_VIEW_STATE,
    };
  };